<template name = "dateTemplate" lang="html">
<v-app id="inspire">
		<!-- Create From -->
		<!-- Top bar-->
	<div class="row">
		<b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="true"></b-loading>
		<div id="header"></div>
		<div class="row">
			<div id="sidebarMenu" class="sidebar sidebar-fixed bg-white">
				<div class="sidebar-header">
					<h5>Search</h5>
					<a href="" id="sidebarMenuClose"><i data-feather="x"></i></a>
				</div><!-- df-sidebar-header -->
				<div class="sidebar-body"></div>
			</div><!-- sidebar-body -->
		</div><!-- sidebar -->
		<div class="content content-components">
			<div class="container pd-x-0 pd-lg-x-12 pd-xl-x-0 bs">  
				<div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
					<div>
						<nav aria-label="breadcrumb">
							<ol class="breadcrumb breadcrumb-style1 mg-b-10">
							<li class="breadcrumb-item">{{this.mainName}}</li>
							<li class="breadcrumb-item active" aria-current="page">{{this.subName}}</li>
							</ol>
							<h4 class="mg-b-0 tx-spacing--1">{{this.subName}}</h4>
						</nav>
					</div>
					<div class="d-none d-md-block">
						<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" v-on:click="createData()"><i data-feather="folder" class="wd-10 mg-r-5"></i>Save</button>
						<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" v-on:click="goList()"><i data-feather="file" class="wd-10 mg-r-5"></i>list</button>
					</div>
				</div>
				<div class="mg-t-50">
                    <div class="card ht-100p">
                        <div class="row row-xs">
                            <div class="col-sm-6 col-lg-12">
                                <div class="card card-body flex-column-inherit">
    							    <div class="col-sm-6 col-lg-5 d-inline-block">
                                        <form action="form-validation.html" data-parsley-validate class="card-body list-group list-group-flush tx-13list-group list-group-flush tx-13 d-block">
                                            <div class="list-group-item list-group-item-padding" v-for="(form, i) in inputSearchForms ">
                                                <div class="form-group">
                                                    <label :for="form.id" class="">{{form.name}}<span class="tx-danger" v-if="form.attr == 'equipmentname'">*</span></label>
                                                    <input type="email" class="form-control" :name="form.id" v-model.lazy="equipmentData[form.id]" :id="form.id" :placeholder="form.name">
                                                </div>
                                            </div>
                                            <div class="form-row col-md-5 d-block" v-for="(form, i) in radioSearchForms">
                                                <div class="form-group">
                                                    <label class="label-title">{{form.name}}</label>
                                                    <div class="ml-2 custom-control custom-radio mb-1" v-for="(form1, i) in form.value">
                                                        <input type="radio" :id="form1.codeCode" :name="form.id" :value="form1.codeCode" v-model="equipmentData[form.id]" class="custom-control-input" :checked="form1.codeCode == equipmentData[form.id]">
                                                        <label class="custom-control-label" :for="form1.codeCode">{{form1.codeName}}</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="modeRedering form-row float-left" v-if="this.saveMode=='update'">
                                                <div class="form-group">
                                                    <label class="label-title">Status</label>
                                                    <div class="input-group">
                                                        <div class="ml-2 custom-control custom-radio mb-1">
                                                            <input type="radio" v-model.trim="usedCode" name="usedcode" id="usedcode1" value="1" class="custom-control-input">
                                                            <label class="custom-control-label" for="usedcode1">Used</label>
                                                        </div>
                                                        <div class="ml-2 custom-control custom-radio mb-1">
                                                            <input type="radio" v-model.trim="usedCode" name="usedcode" id="usedcode0" value="0" class="custom-control-input form-check-input">
                                                            <label class="custom-control-label" for="usedcode0">Unused</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div class="col-sm-6 col-lg-5 d-inline-block">
                                        <form action="form-validation.html" data-parsley-validate class="card-body list-group list-group-flush tx-13list-group list-group-flush tx-13 d-block">
                                            <div class="list-group-item list-group-item-padding">
                                                <div class="form-group">
                                                    <label class="">비고</label>
                                                    <b-input maxlength="200" type="textarea"></b-input>
                                                </div>
                                                <div class="form-group">
                                                    <label class="">이미지</label>
                                                    <ul class="sidebar-nav">
                                                        <li class="d-block mb-1 has-text-weight-semibold">Sample Box Image upload</li>
                                                    </ul>
                                                    <div>
                                                        <imgUpload @imgFileHandler="this.imgFileHandler"/>
                                                    </div>

                                                    <div class="card card-body p-1 paste-background-color">
                                                            <input type="text" @paste="onPaste" multiple="multiple" class="img-input paste-background-color" placeholder="Paste your images here"></input>
                                                            <img id="pasteImg"/>
                                                            <p id='countPasteImg' class='m-0'></p>
                                                            <!-- <button type="button" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5"><i data-feather="image" class="wd-10 mg-r-5"></i>Upload</button> -->
                                                    </div>
                                                    <v-card v-if="imgData.length > 0">
                                                        <v-carousel>
                                                            <v-carousel-item
                                                            v-for="(item,i) in imgData"
                                                            :key="item.id"
                                                            :src="'data:'+item.type.trim()+';base64,'+ item.img"
                                                            reverse-transition="fade-transition"
                                                            transition="fade-transition">
                                                            <v-btn depressed color="primary" block @click="dialogHandler('delete')">
                                                                Delete Image
                                                            </v-btn>
                                                            <v-dialog v-model="deleteDialog" transition="dialog-bottom-transition" max-width="300" style='z-index:20001;'>
                                                                <div class="text-center">
                                                                    <v-sheet class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block" >
                                                                        <div class="text-body-2 mb-4"> Are you sure you want to delete this image? </div>
                                                                        <v-btn class="ma-1" color="grey" plain @click="deleteDialog = false">Cancel</v-btn>
                                                                        <v-btn :loading="deleteLoading" class="ma-1" color="error" plain @click="deleteImgFile(item)"> Delete </v-btn>
                                                                    </v-sheet>
                                                                </div>
                                                            </v-dialog>
                                                            </v-carousel-item>
                                                        </v-carousel>
                                                    </v-card>
                                                    <v-card-text v-else>
                                                        이미지 없음
                                                    </v-card-text>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div><!-- card -->
	    				    </div>
                        </div>
                    </div>
				</div>	
			</div>
		</div>
	</div>
</v-app>
</template>

<script>
	import common from '@/views/Common/common.js';
    import imgUpload from '@/views/Common/image-upload/imgUpload';
	import imageViewer from "@/views/Common/image-upload/Viewer";

	//암호화
	import {secretKey} from '@/config/config';
	import crypto from 'crypto-js';

	import {bus} from '../../../main';

	export default {
		name: 'Detail',
		props: ['properties'],
		components: {
            imgUpload,
            imageViewer,
		},
		computed: {
			sheetSettings() {
				let settings = this.$store.getters.sheetSettings;
				return settings;
			},
			filteredDataArray() {;
				return this.data.filter((option) => {
					return option.toString().toLowerCase().indexOf(this.companyName.toLowerCase()) >= 0
				});
			}
		},
		data() {
			return {
				mainName: '',
				subName: '',
				menuData: [],
				saveMode: '',

				mid: '', 
				uid: '', 
				msid: '',
				ssid: '',

				equipmentHeader: [],
				inputSearchForms: [],
				radioSearchForms: [],

				equipmentData: [],

				usedCode: '',
				flag: false,

				/* Loading */
				isLoading: false,
				isFullPage: true,

				data: [],
				selected: null,
                imgFileFormData: new FormData,
				imgFileHandleFlag: false,
				pasteForm: new FormData,
				pasteFlag: false,
				pasteCount:0,
				imgId: [],
				imgData: [],
                imgDialog : false,
                deleteDialog : false,
                deleteLoading : false,
                selectImg : {},
			}
		},
		beforeDestroy(){
			bus.$off('menu_data');
		},
		created() {
			bus.$on('menu_data', (data)=>{
				this.menuData = data;
				this.classifyHeader();
                this.getImgFile();
				this.modeFilter();
			});
			this.uid = this.properties.uid;
			this.mid = this.properties.mid;

		},
		mounted() {
		
		},
		methods : {
			async classifyHeader() {
				try{
					let data = common.menuHeader(this.properties.mid, this.menuData, 3);
					this.mainName = data[0];
					this.subName  = data[1];
					this.msid = data[2];
					this.equipmentHeader = data[3];
					this.inputSearchForms = [];
					this.radioSearchForms = [];

					for(let i in this.equipmentHeader){
						if(this.equipmentHeader[i].columnType == "LIST"){
							if(this.equipmentHeader[i].columnAttr != 'usedcode'){
								this.radioSearchForms.push({'name':this.equipmentHeader[i].columnName, 'id':this.equipmentHeader[i].columnCode, 'value':this.equipmentHeader[i].code, 'division':this.equipmentHeader[i].columnDivision, 'attr':this.equipmentHeader[i].columnAttr});
							}
						}else if(this.equipmentHeader[i].columnType == "STRING"){
							if(this.equipmentHeader[i].columnAttr != 'creator') this.inputSearchForms.push({'name':this.equipmentHeader[i].columnName, 'value':'', 'id':this.equipmentHeader[i].columnCode, 'division':this.equipmentHeader[i].columnDivision, 'attr':this.equipmentHeader[i].columnAttr});
						}
					}
				}catch (error) {console.log(error)}
			},
			goList() {
				if (this.flag) {
					//등록, 수정 완료시 바로 리스트로 가기때문에 
				} else {
					const result = confirm("You didn't do anything. Would you like to go to the list?");
					if (result) this.$router.push({name:this.$route.name.replace('_detail',''), params:{mid:this.mid, type:'list'}});
					else return false;
				}
			},
			async modeFilter() { //create, update 구분
				try{
					if (this.properties.uid) {//update
						this.saveMode = 'update';
						//update data가져오기
						await this.$axios.get(this.$apiHost + '/'+this.$route.name.replace('_detail','')+'/detail', {params:{id:this.properties.uid, sid: this.msid }})
						.then(res => {
							this.equipmentData = res.data
							this.usedCode = res.data.usedCode;
						}).catch((error) => {});
					} else {//insert
						this.saveMode = 'insert';
					}
				}catch (error) {console.log(error)}
			},
			async createData() {
				try{
					var params = [];
					var sendKey = '';
					var sendValue = '';
					params = { msid: this.msid, uid: this.uid, msid: this.msid, savemode: this.saveMode, usedcode: this.usedCode };
					for(let i in this.equipmentHeader){
						sendKey = this.equipmentHeader[i].columnCode;
						sendValue = this.equipmentData[this.equipmentHeader[i].columnCode];
						if(this.equipmentHeader[i].columnAttr == 'equipmentname'){
							if(common.isNull(sendValue)){
								this.$buefy.dialog.alert({
									message: 'Please Enter '+ this.equipmentHeader[i].columnName,
									size: 'is-medium',
									type: 'is-danger'
								});
								return false;
							}
						}
						if(sendValue){
							params[sendKey] = sendValue
						}
					}
					var request = { params: params };
					if (confirm('Do you want to save it?')) {
						this.$axios.post(this.$apiHost + '/'+this.$route.name.substring(0, this.$route.name.indexOf('_')), request).then((res) => {
                            this.upload();
							if (res.data.deduplication) {//중복
								alert(res.data.msg);
								this.userId = "";
								this.$refs.userId.focus();
							} else if (!res.data.deduplication) { //등록 완료
								var result = confirm('You have created user. Would you like to leave?');
								if (result) {
									this.$router.push({name:this.$route.name.replace('_detail',''), params:{mid:this.mid, type:'list'}});
								} else {
									return false;
								}
							}
						});
					}
				}catch (error) {console.log(error)}
			},
            async upload() {
                if (this.imgFileHandleFlag || this.pasteFlag || this.imgId.length > 0) {
                    try {
                        let formData = new FormData();
                        if (this.imgFileHandleFlag) {
                            formData = this.imgFileFormData;
                        } 
                        if (this.pasteFlag) {
                            for (let pair of this.pasteForm.entries()) {
                                formData.append(pair[0], pair[1]);
                            }
                        }
                        formData.append('uid', this.properties.uid);
                        formData.append('copyId', this.imgId);
                        formData.append('gubun', 'equipment');
                        console.log(formData)
                        await this.$axios.post(`${this.$apiHost}/${this.$route.name.replace("_detail", "")}/upload`, formData, {
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            }
                        }).then(console.log('then')).catch(err=>{console.log(err)})
                        return false;
                    } catch (error) {
                        console.log(error)						
                        return false;
                    }
                }
            },
            async onPaste(evt) {
                this.pasteFlag = true;
                let file = evt.clipboardData.files[0];
                if (file) {
                    this.boolChange = true;
                    this.pasteForm.append('file', file);
                    let reader = new FileReader();
                    var imgtag = document.getElementById("pasteImg");
                    reader.onloadend = function () {
                        imgtag.src = reader.result;
                    }
                    this.pasteCount++;

                    reader.readAsDataURL(file);
                    document.getElementById('countPasteImg').innerHTML = this.pasteCount + ' file(s) selected';
                } else {
                    this.$buefy.dialog.alert({
                        message: 'Please paste only the file',
                        size: 'is-medium',
                        type: 'is-danger'
                    })
                }
		    },
            imgFileHandler(files) {
                if (files.length > 0) {
                    let tForm = new FormData();
                    for (let i in files) {
                        tForm.append('file', files[i])
                    }
                    let formData = new FormData();
                    for (let pair of tForm.entries()) {
                        formData.append(pair[0], pair[1]);
                    }
                    this.imgFileFormData = formData;
                    this.imgFileHandleFlag = true;
                    this.boolChange = true;
                } else {
                    this.imgFileHandleFlag = false;
                }
		    },
            dialogHandler(input) {
                if(input == 'img'){
                    this.imgDialog = true;
                }else if(input == 'delete'){
                    this.deleteDialog = true;
                }
            },
            async upload() {
                if (this.imgFileHandleFlag || this.pasteFlag || this.imgId.length > 0) {
                    try {
                        let formData = new FormData();
                        if (this.imgFileHandleFlag) {
                            formData = this.imgFileFormData;
                        } 
                        if (this.pasteFlag) {
                            for (let pair of this.pasteForm.entries()) {
                                formData.append(pair[0], pair[1]);
                            }
                        }
                        formData.append('uid', this.properties.uid);
                        formData.append('copyId', this.imgId);
                        formData.append('gubun', 'equipment');
                        console.log(formData)
                        await this.$axios.post(`${this.$apiHost}/${this.$route.name.replace("_detail", "")}/upload`, formData, {
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            }
                        }).then(console.log('then')).catch(err=>{console.log(err)})
                        return false;
                    } catch (error) {
                        console.log(error)						
                        return false;
                    }
                }
		    },
            async getImgFile() {
                //img 가져오기
                console.log(1)

                if(!common.isNull(this.properties.uid)){
                    console.log(2)
                    var params = []; 
                    params = {'uid' : this.properties.uid};
                    var request = {params : params}
                    await this.$axios.get(`${this.$apiHost}/${this.$route.name.replace("_detail", "")}/image`, request)
                    .then(res=>{
                        for (let i in res.data) {
                            this.imgData.push(res.data[i]);
                        }
                        if (!common.isNull(this.imgData)) {
                            for (let i in this.imgData) {
                                this.imgId.push(this.imgData[i].id);
                                let image = this.imgData[i].img;
                            }
                        }
                    }).catch(err=>{console.log(err)});
                }
                console.log(this.imgData) 
            },
		    async deleteImgFile(param) {
                try {
                    var params = []; 
                    params = {'id' : param.id};
                    var request = {params : params}
                    this.imgId.splice(this.imgId.indexOf(param.id),1);
                
                    if (!common.isNull(param.id)) {
                        await this.$axios.delete(this.$apiHost + '/'+this.$route.name.replace('_detail','') + '/delimage', request)
                        .then(res => {
                            if (res.data) {
                                this.$router.go({name:this.$route.name});
                                // this.$buefy.dialog.alert({
                                // 	message: 'Complete!',
                                // 	size: 'is-medium',
                                // 	type: 'is-danger'
                                // })
                            return false;
                            }
                        });
                    }
                } catch (error) {
                    console.log(error)
                }
		    },
		},
		watch: {
		},
	}
</script>
<style src="../../../../node_modules/handsontable/dist/handsontable.full.css"></style>
<style scoped>
	@import '../../../assets/css/buefy.css';
</style>


// WEBPACK FOOTER //
// src/views/Sequencing/Equipment/DetailForm.vue